import axios from './index'

// Destek talepleri Estesoft web ile aynı uçlara yazılır ve 007'ye aynı yoldan düşer.
export default {
  getTickets() {
    return axios.get('/Ticket/GetTickets')
      .then(response => response.data);
  },
  getTicket(ticketId) {
    return axios.get('/Ticket/GetTicket', { params: { ticketId } })
      .then(response => response.data);
  },
  getMultimedia(ticketId) {
    return axios.get('/Ticket/GetMultimedia', { params: { ticketId } })
      .then(response => response.data);
  },
  // Dosya adresi açılış anında imzalanır; uç talep sahibinin tenant'ıyla sınırlıdır.
  getSignedUrl(multimediaId) {
    return axios.post('/Softage/GetSignedUrl', null, { params: { id: multimediaId } })
      .then(response => response.data);
  },
  getUnreadAnswers() {
    return axios.get('/Ticket/GetUnreadAnswers')
      .then(response => response.data);
  },
  getNewTicketContext() {
    return axios.get('/Ticket/GetNewTicketContext')
      .then(response => response.data);
  },
  insertTicket(model) {
    return axios.post('/Ticket/InsertTicket', model)
      .then(response => response.data);
  },
  sendAnswer(model) {
    return axios.post('/Ticket/SendAnswer', model)
      .then(response => response.data);
  },
  uploadFiles(ticketId, files) {
    const form = new FormData();
    files.forEach((file, i) => form.append('Files[' + i + ']', file));

    return axios.post('/Ticket/UploadFile', form, {
      headers: { 'Content-Type': 'multipart/form-data', 'ticketId': ticketId }
    }).then(response => response.data);
  },
  closeTicket(ticketId) {
    return axios.post('/Ticket/CloseTicket', null, { params: { id: ticketId } })
      .then(response => response.data);
  },
  deleteTicket(ticketId) {
    return axios.post('/Ticket/DeleteTicket', null, { params: { id: ticketId } })
      .then(response => response.data);
  }
}
